<template>
	<div class="allchain">
		<leftnav class="fl" mkcode="MMM" :itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
						<span class="title" :class="{'current':navValue == list.value}" @click="navValue = list.value;workTypeList = list.childern;ajaxsearchcompany();" v-for="(list) in navList" :key="list.value">{{list.label}}</span>
					</div>
                    <dl class="opport-screen bdbe">
                        <dt class="fl">统计类型{{ searchData.type }}</dt>
                        <dd class="fl "> 
                            <!-- <span @click="searchData.type = 'all';ajaxsearchcompany();" :class="searchData.type == 'all' ?'a-screen current' : 'a-screen'"  >全部 </span> -->
                            <span :key="index" v-for="(item,index) in workTypeList" @click="searchData.type = item.value;ajaxsearchcompany();"
                                :class="searchData.type == item.value ?'a-screen current' : 'a-screen'"
                                >{{item.label}} </span>
                                    
                        </dd>
                    </dl>
                    <dl class="opport-screen bdbe">
                        <dt class="fl">投资日期</dt>
                        <dd class="fl "> 
                             <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" size="large" v-model="searchData.startTime" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="searchData.endTime" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                            <el-button :disabled="searchData.startTime == '' || searchData.endTime == ''" class="ml-2" size="small" type="primary" @click="ajaxsearchcompany();">确定</el-button>
                        </dd>
                    </dl>
                    <!-- <dl class="opport-screen bdbe"  v-show="searchData.type == 3">
                        <dt class="fl">土地性质</dt>
                        <dd class="fl "> 
                            <span @click="searchData.landType = '';ajaxsearchcompany();" :class="searchData.landType == '' ?'a-screen current' : 'a-screen'"  >全部 </span>
                            <span :key="index" v-for="(item,index) in landTypeList" @click="searchData.landType = item.value;ajaxsearchcompany();"
                                :class="searchData.landType == item.value ?'a-screen current' : 'a-screen'"
                                >{{item.name}} </span>
                                    
                        </dd>
                    </dl> -->
                    <dl class="opport-screen bdbe"  v-show="searchData.type == 4">
                        <dt class="fl">行业分类</dt>
                        <dd class="fl "> 
                            <span @click="searchData.industry = '';ajaxsearchcompany();" :class="searchData.industry == '' ?'a-screen current' : 'a-screen'"  >全部 </span>
                            <span :key="index" v-for="(item,index) in notionClassList1" @click="searchData.industry = item.paraValue;ajaxsearchcompany();"
                                :class="searchData.industry == item.paraValue ?'a-screen current' : 'a-screen'"
                                >{{item.paraName}} </span>
                                    
                        </dd>
                    </dl>
				</div>
				<div class="whitebox">
					<div class="pb-3 pt-2">
                       <table border="0" cellspacing="0" cellpadding="0" class="land_table">
							<tr>
                                <th>名次</th>
                                <th>{{ searchData.type == 1 || searchData.type == 2 ? '区域' :searchData.type == 3  ? '按接受单位' : '行业' }}</th>
                                <th>拿地项目数</th>
                                <th>拿地金额（亿元）</th> 
                            </tr>  
                            <tr v-for="(item,index) in enterpristlist" :key="index"> 
                                <td class="text-center">{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.name || '-'}}</td>
                                <td>{{item.count || '-'}}</td>
                                <td>{{item.price || '-'}}</td>
                            </tr>
                    </table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
	name: 'investWork',
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "",
			curWebsite: this.$api.getWebsiteType(),
			userdata: {},
			yj_itemcode: "E02",
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 20, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
            enterpristlist: [],
            navList: [
                {value:1,label:'项目检索统计',
                childern:[
                    {value:1,label:'线索管理项目统计表（按省份）'},
                    {value:2,label:'线索管理项目统计表（按城市）   '},
                    {value:3,label:'线索管理项目统计表（按土地用途）    '},
                    {value:4,label:'线索管理项目统计表（按行业）    '},
                ]},
                {value:2,label:'项目监测统计',
                   childern:[
                    {value:1,label:'线索管理项目统计表（按省份）'},
                    {value:2,label:'线索管理项目统计表（按城市）   '},
                    {value:3,label:'线索管理项目统计表（按土地用途）    '},
                    {value:4,label:'线索管理项目统计表（按行业）    '},
                ] 
                },
                {value:3,label:'项目推送统计',
                    childern:[
                    {value:1,label:'已推送项目统计表（按省份）'},
                    {value:2,label:'已推送项目统计表（按城市）   '},
                    {value:3,label:'已推送项目统计表（按接受单位）    '},
                    {value:4,label:'已推送项目统计表（按行业）    '},
                    ]
                },
            ],
            workTypeList: [],
            navValue: 1,
            landTypeList: [],
            notionClassList1: [],
            searchData: {
                type: 1,
                startTime: '',
                endTime: '',
                landType: '',
                industry: '',

            },
		}
	},
	created() {
        this.bus.$emit('loading', false);
    },
	mounted() { 
        this.ajaxsearchcompany(1);
        this.workTypeList = this.navList[0].childern;
        this.getIndustryList();
    },
	methods: {
        //获取行业分类
        getIndustryList() { 
            this.$axios.get(this.$api.metall.investParam.KeyIndustry()).then((res) => {
               if (res.data.success) { 
                console.log('行业分类',res);
                this.notionClassList1 = res.data.list;
               } else {
                   this.$message.error(res.data.message);
               }
           })
        },
        ajaxsearchcompany(pages) {
            this.page = pages ? pages : 1;
            this.bus.$emit('loading', true);
            for(let key in this.searchData){
                if(this.searchData[key] == '' || this.searchData[key] == 0){
                    delete this.searchData[key];
                }
            }
            let ajxurl = this.$api.metall.InvestWork.Thread();
            if(this.navValue == 1){
                ajxurl = this.$api.metall.InvestWork.Thread();
            }else if(this.navValue == 2){ 
                ajxurl = this.$api.metall.InvestWork.Monitor();
            }else if(this.navValue == 3){ 
                ajxurl = this.$api.metall.InvestWork.Push();
            }
            let params = {
                page: this.page,
                pageSize: this.pageSize,
                ...this.searchData
            };
           this.$axios.get(ajxurl, { params: params }).then((res) => {
               if (res.data.success) { 
                this.enterpristlist = res.data.list;
                this.totalPage = res.data.totalPage;
                this.total = res.data.totalRecord;
                this.pageSize = res.data.pageSize;
                this.bus.$emit('loading', false);
               } else {
                //    this.$message.error(res.data.message);
                    this.bus.$emit('loading', false);
               }
           })
        },
        pageHandler(page) { 
            this.page = page;
            this.ajaxsearchcompany(page);
        },
    },
}
</script>

<style lang="scss" >

.collectfont1{
    font-size: 14px;
    color: #305ea3;
    cursor: pointer;
    &:hover{
        color: #f19d00;
    }
}
.land_table{
    margin:  0 auto;
    border: 1px solid #f2f2f2; 
    background: #fff;
    width: 95%;
    font-size: 14px;
    .title{
        cursor: pointer;
        color: #305ea3;
        &:hover{
            color: #f19d00;
            text-decoration: underline;
        } 
    }
    th{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    height: 54px;
    line-height: 54px;
    background: #f2f8fe;
    white-space: nowrap;
    padding: 0 10px;
    border-right: 1px solid #dcdcdc;
    }
    tr{
        height: 40px;
        border-bottom: 1px solid #dcdcdc;
        td{
            text-align: center;
            border-right: 1px solid #dcdcdc;
            padding: 0 10px;
            border-bottom: 1px solid #dcdcdc;
        }
    }
}
</style>